export default __webpack_public_path__ + "static/76dbc377-7a7b-452e-90e5-4c607cf94c47-79576fca477481b61c47e8cb51d148aa.woff2";